const dialog = document.querySelector("[data-route-gallery-dialog]");
const photos = [...document.querySelectorAll("[data-route-gallery-photo]")];
const triggers = [...document.querySelectorAll("[data-route-gallery-trigger]")];

if (dialog && photos.length && triggers.length) {
  const image = dialog.querySelector("[data-gallery-image]");
  const count = dialog.querySelector("[data-gallery-count]");
  const thumbnails = [
    ...dialog.querySelectorAll("[data-gallery-thumbnail]"),
  ];
  let currentIndex = 0;
  let returnFocus = null;
  let swipeStartX = null;

  function showPhoto(index) {
    currentIndex = (index + photos.length) % photos.length;
    const photo = photos[currentIndex];
    image.src = photo.dataset.galleryUrl;
    image.alt = photo.dataset.galleryAlt;
    count.textContent = `${currentIndex + 1} / ${photos.length}`;
    for (const thumbnail of thumbnails) {
      const selected =
        Number(thumbnail.dataset.galleryThumbnail) === currentIndex;
      thumbnail.classList.toggle("is-selected", selected);
      thumbnail.setAttribute("aria-current", selected ? "true" : "false");
      if (selected) {
        thumbnail.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center",
        });
      }
    }
  }

  function openViewer(index, trigger) {
    returnFocus = trigger;
    dialog.showModal();
    showPhoto(index);
  }

  function closeViewer() {
    dialog.close();
  }

  for (const trigger of triggers) {
    trigger.addEventListener("click", () =>
      openViewer(Number(trigger.dataset.galleryIndex), trigger),
    );
  }

  dialog.addEventListener("click", (event) => {
    const action = event.target.closest("[data-gallery-action]")?.dataset
      .galleryAction;
    if (action === "close") closeViewer();
    if (action === "previous") showPhoto(currentIndex - 1);
    if (action === "next") showPhoto(currentIndex + 1);
    if (event.target === dialog) closeViewer();

    const thumbnail = event.target.closest("[data-gallery-thumbnail]");
    if (thumbnail) {
      showPhoto(Number(thumbnail.dataset.galleryThumbnail));
    }
  });

  dialog.addEventListener("keydown", (event) => {
    if (event.key === "ArrowLeft") showPhoto(currentIndex - 1);
    if (event.key === "ArrowRight") showPhoto(currentIndex + 1);
  });
  dialog.addEventListener("close", () => returnFocus?.focus());

  dialog
    .querySelector(".vertex-photo-viewer__stage")
    .addEventListener(
      "touchstart",
      (event) => {
        swipeStartX = event.changedTouches[0]?.clientX ?? null;
      },
      { passive: true },
    );

  dialog
    .querySelector(".vertex-photo-viewer__stage")
    .addEventListener(
      "touchend",
      (event) => {
        if (swipeStartX === null) return;
        const distance = (event.changedTouches[0]?.clientX ?? swipeStartX) -
          swipeStartX;
        swipeStartX = null;
        if (Math.abs(distance) < 45) return;
        showPhoto(currentIndex + (distance < 0 ? 1 : -1));
      },
      { passive: true },
    );
}
